import React from "react";

export default function Metaverse()
{
  return (
    <section id="metaverse" className="home-Metaverse">
      <div className="block_50  "></div>
      <div className="block_50 hidden_mb "></div>
      <div className="sc-content wow fadeInUp">
        <div className="left">
          <h3>
            Social Network</h3>
          <div className="block_10  "></div>
          <div className="list_icon">
            <a href="">
              <div className="ic__ ic__1 bg_contain">

              </div>
            </a>
            <a href="">
              <div className="ic__ ic__2 bg_contain">

              </div>
            </a>
            <a href="">
              <div className="ic__ ic__3 bg_contain">

              </div>
            </a>

          </div>
          <div className="block_10  "></div>
          <div className="block_10  "></div>
        </div>

        <div className="right">
          <h3>
            We were listed on</h3>
          <div className="block_10  "></div>
          <div className="list_icon list_icon_2">
            <a href="">
              <div className="ic__ ic__4 bg_contain">

              </div>
            </a>
            <a href="">
              <div className="ic__ ic__5 bg_contain">

              </div>
            </a>
            <a href="">
              <div className="ic__ ic__6 bg_contain">

              </div>
            </a>
            <a href="">
              <div className="ic__ ic__7 bg_contain">

              </div>
            </a>
            <a href="">
              <div className="ic__ ic__8 bg_contain">

              </div>
            </a>
          </div>
        </div>

      </div>

    </section>
  );
}
